import { forwardRef, useMemo } from 'react'
import { buildCalendarOption, calendarHeight, calendarYears, type CalendarInput } from './calendarOption'
import { EChart, type EChartHandle } from './EChart'
import { useChartTheme } from './useChartTheme'

export interface CalendarHeatmapProps extends CalendarInput {
  height?: number
  loading?: boolean
  ariaLabel?: string
  className?: string
  /** Клик по дню (`YYYY-MM-DD`). */
  onDayClick?: (date: string) => void
}

/** Год по дням: сезонность темы, дни без остатка. Несколько лет — друг под другом с общей шкалой. */
export const CalendarHeatmap = forwardRef<EChartHandle, CalendarHeatmapProps>(function CalendarHeatmap(
  { height, loading, ariaLabel, className, onDayClick, ...input },
  ref,
) {
  const theme = useChartTheme()
  const years = input.years && input.years.length > 0 ? input.years : calendarYears(input.days)
  const option = useMemo(
    () => buildCalendarOption(input, theme),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [theme, input.days, input.years, input.valueFormat, input.valueLabel, input.markedDates, input.markedLabel],
  )

  return (
    <EChart
      ref={ref}
      option={option}
      height={height ?? calendarHeight(years.length)}
      loading={loading}
      ariaLabel={ariaLabel}
      className={className}
      onMarkClick={(params) => {
        if (params.componentType !== 'series') return
        const value = (params.data?.value ?? params.value) as unknown
        if (Array.isArray(value) && typeof value[0] === 'string') onDayClick?.(value[0])
      }}
    />
  )
})

export default CalendarHeatmap
